import React from 'react';

import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import { TailNumber } from 'ff/debrief/models';
import { useGetRecentTailNumbersQuery } from 'ff/debrief/features/TracklogApi';

const filter = createFilterOptions<TailNumber>();

interface Props {
    value: TailNumber;
    onChange: (newValue: TailNumber) => void;
    disabled?: boolean;
}

const TailNumberField = (props: React.PropsWithChildren<Props>) => {
    const { data: recentTails, isLoading } = useGetRecentTailNumbersQuery(null);

    return (
        <Autocomplete
            sx={{ pr: 2, flexGrow: 1 }}
            options={
                recentTails?.map(t => ({ label: t.tailNumber, ...t })) || []
            }
            value={props.value}
            onChange={(evt, newValue) => {
                if (typeof newValue === 'string') {
                    props.onChange({
                        tailNumber: newValue,
                        label: newValue,
                        manufacturer: '',
                        model: '',
                    });
                } else {
                    props.onChange(newValue);
                }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                const isExisting = options.some(
                    option => inputValue === option.tailNumber
                );
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        tailNumber: inputValue,
                        label: `Add "${inputValue}"`,
                        manufacturer: '',
                        model: '',
                    });
                }
                return filtered;
            }}
            loading={isLoading}
            disabled={props.disabled}
            disableClearable
            renderInput={params => (
                <TextField {...params} label="Tail Number" variant="standard" />
            )}
        />
    );
};

export default TailNumberField;
